/**
 * Who provides SchoolOne — the one place the legal identity lives.
 *
 * Every footer, the Terms, the Data Processing Agreement, the privacy and
 * cookie policies and the accepted-document header read from here, so a
 * change of entity is one edit and one legal-version bump, never a hunt
 * through the site. Changing COMPANY_NAME or the legal line changes the
 * contracting party in the Terms and DPA: bump CURRENT_LEGAL_VERSION in
 * components/legal/LegalContent.tsx so every school re-accepts.
 */
export const COMPANY_NAME = 'Parker Tech Ltd';
export const TRADING_AS = 'SchoolOne';
/** Companies House number. */
export const COMPANY_NUMBER = '17350197';
/** Registered office, as shown at Companies House. */
export const REGISTERED_OFFICE = 'Suite 2, Second Floor North, Chatham, Kent, ME4 4TZ';
export const CONTACT_EMAIL = 'hello@schoolone.co.uk';

/** "Parker Tech Ltd, a company registered in England and Wales (company number …)" */
export const COMPANY_LEGAL_LINE = `${COMPANY_NAME}, a company registered in England and Wales (company number ${COMPANY_NUMBER})`;
/** For footers and contact blocks: "Parker Tech Ltd · Trading as SchoolOne" */
export const COMPANY_SHORT_LINE = `${COMPANY_NAME} · Trading as ${TRADING_AS}`;
/** For the accepted-document header. */
export const COMPANY_PROVIDER_LINE = `${COMPANY_NAME} (company number ${COMPANY_NUMBER}) · ${CONTACT_EMAIL}`;
